module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "dark-top",
    attrs: {
      "dialog": "modal-lg",
      "header": false,
      "customClass": 'heightAuto',
      "footer": true
    },
    on: {
      "close": _vm.cancel
    }
  }, [_c('div', {
    staticClass: "p-4",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [(_vm.getIsLoadingReasons) ? _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('loader', {
    attrs: {
      "size": "small"
    }
  })], 1) : _c('div', [(_vm.isToShowTopMessage) ? _c('div', [_c('h2', {
    staticClass: "text-center mb-3"
  }, [_vm._v("What do you want to do?")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex h-100 justify-content-between align-items-center py-4"
  }, [_c('button', {
    staticClass: "w-100 w-100 mb-2 bg-lightest color-6 text-center font-weight-600 py-3 border-light radius-normal pointer",
    class: {
      'bg-light': _vm.choosedCancelNow,
      'bg-lightest': !_vm.choosedCancelNow
    },
    on: {
      "click": function($event) {
        return _vm.clickedCancelBookingNow()
      }
    }
  }, [_vm._v("Cancel Booking Now")]), _vm._v(" "), _c('div', {
    staticClass: "w-25 d-flex justify-content-center"
  }, [_c('span', [_vm._v(" - OR - ")])]), _vm._v(" "), _c('button', {
    staticClass: "w-100 w-100 mb-2 bg-lightest color-6 text-center font-weight-600 py-3 border-light radius-normal pointer",
    class: {
      'bg-light': _vm.choosedRequest,
      'bg-lightest': !_vm.choosedRequest
    },
    on: {
      "click": function($event) {
        return _vm.clickedRequestCancelBooking()
      }
    }
  }, [_vm._v("Request Cancelation")])]), _vm._v(" "), (_vm.choosedCancelNow) ? _c('div', [_vm._v("You choosed cancel now! This means that we will not notify " + _vm._s(_vm.reservation.channelTypeDescription) + ". This booking will be immediately cancelled.")]) : _vm._e(), _vm._v(" "), (_vm.choosedRequest) ? _c('div', [_c('p', {
    staticClass: "mb-3"
  }, [_vm._v("\n\t\t\t\t\tPlease type a reason for this cancellation request. We will notify " + _vm._s(_vm.reservation.channelTypeDescription) + " with this.\n\t\t\t\t\t")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('label', {
    attrs: {
      "for": "cancellationReason"
    }
  }, [_vm._v("\n\t\t\t\t\tCancellation reason\n\t\t\t\t\t"), (_vm.isFoundReasonsAllBookings) ? _c('span', {
    staticClass: "color-6"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), (_vm.filteredReasons.length > 0) ? _c('v-select', {
    attrs: {
      "id": "cancellationReason",
      "options": _vm.filteredReasons,
      "reduce": function (reason) { return reason.id; },
      "label": "description",
      "placeholder": "Select a reason"
    },
    on: {
      "input": function($event) {
        return _vm.updateReason(_vm.reasonObject)
      }
    },
    model: {
      value: (_vm.reasonObject),
      callback: function($$v) {
        _vm.reasonObject = $$v
      },
      expression: "reasonObject"
    }
  }) : _vm._e(), _vm._v(" "), (!!_vm.reasonObject && !_vm.reservation.cancelationReasonId) ? _c('label', {
    staticClass: "full mt-1"
  }, [_vm._v("\n\t\t\t\t\tCancellation description\n\t\t\t\t\t"), (_vm.isFoundReasonsAllBookings) ? _c('span', {
    staticClass: "color-6"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservation.cancelationNote),
      expression: "reservation.cancelationNote"
    }],
    ref: "cancelationNote",
    staticClass: "bg-lighter w-100 mt-1",
    attrs: {
      "rows": "2",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.reservation.cancelationNote)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reservation, "cancelationNote", $event.target.value)
      }
    }
  })]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-all",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn cancel wider",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn ok wider",
    attrs: {
      "type": "button",
      "disabled": _vm.isInvalidValid || _vm.getIsLoadingReasons
    },
    on: {
      "click": _vm.continueAndClose
    }
  }, [_c('span', [_vm._v("Continue")])]), _vm._v(" "), (_vm.defaultCancelPaymentTypeName !== null) ? _c('button', {
    staticClass: "btn ok wider",
    attrs: {
      "type": "button",
      "disabled": _vm.isInvalidValid || _vm.getIsLoadingReasons || !_vm.refundsOrPayOutAllowed
    },
    on: {
      "click": _vm.continueToOptionModal
    }
  }, [_vm._v("\n\t\t\tContinue to " + _vm._s(_vm.defaultCancelPaymentTypeName) + "\n\t\t")]) : _vm._e()])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-5ffea751", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ffea751"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationCancelReason.vue
// module id = 1656
// module chunks = 0